// extracted by mini-css-extract-plugin
module.exports = {"messengersCheckBox":"MessengersCheckbox-module--messengersCheckBox--1RW5V","messengersCheck":"MessengersCheckbox-module--messengersCheck--3lUJG"};